import Swal from 'sweetalert2/dist/sweetalert2.js';
import i18n from '../libraries/I18n.js';

import 'sweetalert2/src/sweetalert2.scss';

export default {
    /**
     * Show fail alert
     *
     * @param    {string}   message   fail message
     *
     */
    fail (message) {
        Swal.fire({
            position:           'bottom-end',
            icon:               'error',
            title:              i18n.t('error'),
            text:               message,
            showCloseButton:    true,
            allowEscapeKey:     false,
            showConfirmButton:  false,
            confirmButtonColor: '#0c5748',
            toast:              true,
            timer:              6000,
            timerProgressBar:   true
        });
    },

    /**
     * Show success alert
     *
     * @param    {string}   message   success message
     *
     */
    success (message) {
        Swal.fire({
            position:           'bottom-end',
            icon:               'success',
            title:              i18n.t('success'),
            html:               message,
            showCloseButton:    true,
            allowEscapeKey:     false,
            confirmButtonColor: '#0c5748',
            showConfirmButton:  false,
            toast:              true,
            timer:              6000,
            timerProgressBar:   true
        });
    },

    /**
     * Show invalid token alert
     *
     * @param    {string}    refreshTokenMessage     the alert message.
     * @param    {string}    contactAdminMessage     the alert message.
     * @param    {string}    connectionLink          the connection link.
     *
     * @return    void
     */
    invalidTokenAlert (refreshTokenMessage, contactAdminMessage, connectionLink) {
        Swal.fire({
            position:          'top',
            width:             '100%',
            title:             `<div class="row invalid-token-alert"><div class="col-1 pl-0 text-right top-exclamation-alert"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-triangle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="exclamation-triangle svg-inline--fa fa-exclamation-triangle fa-w-18"><path fill="currentColor" d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z" class=""></path></svg></div><div class="col-7 pl-0 text-left">${refreshTokenMessage} ${contactAdminMessage}</div><div class="col-2 p-0 text-right">${connectionLink}</div><div class="col-2 p-0 text-center"><a href="/help">${i18n.t('learn-more')}</a></div></div>`,
            showCloseButton:   true,
            showConfirmButton: false,
            allowEscapeKey:    false,
            toast:             true,
            showClass:         { popup: 'animate__animated animate__fadeInDown' },
            hideClass:         { popup: 'animate__animated animate__fadeOutUp' },
            customClass:       {
                container: 'ivalid-token-container-class',
                popup:     'ivalid-token-popup-class'
            }
        });
    }
};
